import Joi from '@hapi/joi';
import { SituationForm } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<SituationForm>>({
  situationCategoryID: Joi.number().required().messages({
    'any.required': 'REQUIRED_FIELD',
  }),
  name: Joi.string().required().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export default function (value: Partial<SituationForm>) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
